// Declarar a função gtag_report_conversion do Google Ads
declare global {
  interface Window {
    gtag_report_conversion: (url?: string) => boolean;
  }
}

const FloatingWhatsApp = () => {
  const handleClick = () => {
    // Registrar conversão do Google Ads antes de abrir o WhatsApp
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }
    window.open('https://wa.me/5519981868997', '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl transition-all transform hover:scale-110 animate-bounce cursor-pointer"
      style={{
        position: 'fixed',
        WebkitTransform: 'translateZ(0)',
        transform: 'translateZ(0)',
      }}
      aria-label="Contato WhatsApp"
    >
      <i className="ri-whatsapp-line text-white text-3xl"></i>
    </button>
  );
};

export default FloatingWhatsApp;